import React from 'react';
import {useDispatch} from 'react-redux';
import IconSelector from 'icon-selector/src/icon-selector';
import * as S from './Header.styles';
import {logout} from '@ibibo/user-reducer';

const Header = () => {
  const host = `${__ENV_CONFIG__.AGENTPROXY_HOST}`;
  const dispatch = useDispatch();
  const goBack = () => {
    window.location.href = host;
  };
  return (
    <S.WalletWrap>
      <S.BackIconWrap onClick={goBack}>
        <IconSelector iconKey="headerback" />
      </S.BackIconWrap>
      <S.WallectBlc>
        <S.Text>Settings</S.Text>
      </S.WallectBlc>
      <S.WalletLogout>
        <S.LogoutText
          onClick={() => {
            dispatch(logout());
          }}
        >
          Logout
        </S.LogoutText>
      </S.WalletLogout>
    </S.WalletWrap>
  );
};

export default Header;
